import { SvgIconProps } from "../types";

export const SvgIcon = ({ src, width, height, folder='svg' }: SvgIconProps) => (
  <img src={`/img/${folder}/${src}`} alt={src} width={width} height={height} />
);
